<!-- This Component will show a button that opens a text input when you click on it.  You need to type 'delete' to click the button for real -->
<template>
	<div class="w-full">
		<RegularButton
			aria-label="attempt-delete-on-logout"
			v-if="!showBox"
			@click="handleShowInputClick"
			type="submit"
			class="bg-transparent px-5 py-2 font-bold text-red-500 hover:bg-red-500 hover:text-white"
		>
			{{ t('auth.confirmActionAndDelete', { event: t('auth.logout') }) }}
		</RegularButton>
		<div v-if="showBox">
			<form
				@submit.prevent="handleConfirmLogoutClick"
				class="flex gap-2"
			>
				<input
					class="w-2/3 rounded-md border-slate-300 text-slate-900 uppercase placeholder:text-slate-400 placeholder:italic"
					type="text"
					:placeholder="
						t('auth.validationPlaceHolder', {
							delete: t('auth.deleteValidation'),
						})
					"
					v-model="deleteConfirmation"
				/>
				<RegularButton
					@click="handleConfirmLogoutClick"
					class="bg-transparent px-5 py-2 font-bold"
					:class="[
						hasConfirmedDelete
							? 'cursor-pointer text-red-400 underline'
							: 'pointer-events-none text-slate-400',
					]"
				>
					{{ t('auth.confirmActionAndDelete', { event: t('auth.logout') }) }}
				</RegularButton>
			</form>
		</div>
	</div>
</template>

<script setup lang="ts">
import RegularButton from '@/components/forms/RegularButton.vue'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const emit = defineEmits(['click-delete', 'confirm-logout'])

const { t } = useI18n()
const showBox = ref(false)

const deleteConfirmation = ref('')

const handleShowInputClick = () => {
	showBox.value = true
	emit('click-delete', showBox.value)
}

const hasConfirmedDelete = computed(
	() => deleteConfirmation.value.trim().toUpperCase() === 'DELETE'
)

const handleConfirmLogoutClick = () => {
	if (hasConfirmedDelete.value) {
		emit('confirm-logout')
		showBox.value = false
	}
}
</script>
